var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offline-warning"},[_c('FontAwesomeIcon',{staticClass:"mr-1",attrs:{"icon":_vm.faExclamationTriangle}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('feedback.unableConnectInternet')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }